import addresses from 'config/constants/contracts'

const chainId = process.env.REACT_APP_CHAIN_ID

export const getCoinAddress = () => {
  return addresses.coin[chainId]
}
export const getCoinPresaleAddress = () => {
  return addresses.coinPresale[chainId]
}
export const getCoinUsdtAddress = () => {
  return addresses.coinusdt[chainId]
}
export const getCakeAddress = () => {
  return addresses.cake[chainId]
}
export const getMasterChefAddress = () => {
  return addresses.masterChef[chainId]
}
export const getTimelockAddress = () => {
  return addresses.timelock[chainId]
}
export const getLiqLockerAddress = () => {
  return addresses.liqLocker[chainId]
}
export const getChessAddress = () => {
  return addresses.chess[chainId]
}
export const getMulticallAddress = () => {
  return addresses.multiCall[chainId]
}
export const getWavaxAddress = () => {
  return addresses.wavax[chainId]
}
export const getLotteryAddress = () => {
  return addresses.lottery[chainId]
}
export const getLotteryTicketAddress = () => {
  return addresses.lotteryNFT[chainId]
}
export const getRugdocAddress = () => {
  return addresses.rugdoc[chainId]
}

export const getCakeUsdtAddress = () => {
  return addresses.cakeusdt[chainId]
}
export const getCakeWavaxAddress = () => {
  return addresses.cakewavax[chainId]
}
export const getCakeUsdcAddress = () => {
  return addresses.cakeusdc[chainId]
}
export const getCakeWethAddress = () => {
  return addresses.cakeweth[chainId]
}
export const getCakeDaiAddress = () => {
  return addresses.cakedai[chainId]
}
export const getCakeWbtcAddress = () => {
  return addresses.cakewbtc[chainId]
}
export const getCakeJoeAddress = () => {
  return addresses.cakejoe[chainId]
}
export const getCakeTmtAddress = () => {
  return addresses.caketmt[chainId]
}
export const getCakeCornAddress = () => {
  return addresses.cakecorn[chainId]
}

export const getCornAddress = () => {
  return addresses.corn[chainId]
}
export const getTmtAddress = () => {
  return addresses.tmt[chainId]
}
export const getUsdtAddress = () => {
  return addresses.usdt[chainId]
}
export const getUsdcAddress = () => {
  return addresses.usdc[chainId]
}
export const getWethAddress = () => {
  return addresses.weth[chainId]
}
export const getWbtcAddress = () => {
  return addresses.wbtc[chainId]
}
export const getJoeAddress = () => {
  return addresses.joe[chainId]
}
export const getDaiAddress = () => {
  return addresses.dai[chainId]
}

export const getUsdcUsdtAddress = () => {
  return addresses.usdcusdt[chainId]
}
export const getWavaxUsdtAddress = () => {
  return addresses.wavaxusdt[chainId]
}
export const getWavaxUsdcAddress = () => {
  return addresses.wavaxusdc[chainId]
}
export const getWavaxWethAddress = () => {
  return addresses.wavaxweth[chainId]
}
export const getWethUsdcAddress = () => {
  return addresses.wethusdc[chainId]
}
export const getWbtcUsdcAddress = () => {
  return addresses.wbtcusdc[chainId]
}
export const getJoeUsdcAddress = () => {
  return addresses.joeusdc[chainId]
}
export const getDaiUsdcAddress = () => {
  return addresses.daiusdc[chainId]
}
export const getCornUsdcAddress = () => {
  return addresses.cornusdc[chainId]
}
export const getTmtUsdtAddress = () => {
  return addresses.tmtusdt[chainId]
}
export const getTmtWavaxAddress = () => {
  return addresses.tmtwavax[chainId]
}

export const getRomeAddress = () => {
  return addresses.romefos[chainId]
}
export const getTokyoAddress = () => {
  return addresses.tokyofos[chainId]
}
export const getDenverAddress = () => {
  return addresses.denverfos[chainId]
}
export const getRomeSwapAddress = () => {
  return addresses.swapromefos[chainId]
}
export const getTokyoSwapAddress = () => {
  return addresses.swaptokyofos[chainId]
}
export const getDenverSwapAddress = () => {
  return addresses.swapdenverfos[chainId]
}
